import { createContext, useContext } from 'react';
import { useGlobal } from '@/utils/useGlobal';
import { CustomerSwiper, TextModule } from '..';
import css from './index.module.scss';

const swiperTypes = createContext({
    FULL_IMAGE: 'full_image' || 1,
    FULL_IMAGE_WITH_TEXT_TOP: 'full_image_with_text_top' || 2,
    FULL_IMAGE_WITH_TEXT_BOTTOM: 'full_image_with_text_bottom' || 3,
    CONTAINER_IMAGE_WITH_TEXT_TOP: 'container_image_with_text_top' || 4,
    CONTAINER_IMAGE_WITH_TEXT_BOTTOM: 'container_image_with_text_bottom' || 5,
    CENTER_IMAGE_WITH_TEXT_TOP: 'center_image_with_text_top' || 6,
    CENTER_IMAGE_WITH_TEXT_BOTTOM: 'center_image_with_text_bottom' || 7,
});
const defaultData = {
    guide: { text: 'Interior / Exterior Design' },
    title: { text: 'Power pretty much anything ' },
    desc: {
        text: 'Keep your home comforts running during a blackout. AC units, kitchen appliances and power tools are all accessible with DELTA Pro. Use a single unit to power up to 4500W¹ of appliances. Need even more power? ',
    },
    items: [
        { img: '/img/banner_house_big.jpg', desc: '' },
        { img: '/img/banner_cell_big.jpg', desc: '' },
        { img: '/img/banner_house_big.jpg', desc: '' },
        { img: '/img/banner_cell_big.jpg', desc: '' },
    ],
};
const defaultStyle = {
    type: 'full_image',
    backColor: '#fff',
    guideStyle: {},
    titleStyle: {},
    descStyle: {},
    config: {
        theme: 'white',
        fullScreen: true,
        fullScreenWidth: 1920,
        loop: true,
        pagination: {},
        icon: {},
        list: {},
        animation: {},
        textStyle: {},
    },
};
export default function SwiperBanner({ data, cssStyle }: any) {
    const { useRouter } = useGlobal();
    const { locale } = useRouter();
    const dataObj = {
        guide: { ...defaultData.guide, ...(data?.guide || {}) },
        title: { ...defaultData.title, ...(data?.title || {}) },
        desc: { ...defaultData.desc, ...(data?.desc || {}) },
        items: data?.items || defaultData.items,
    };
    const { guide, title, desc, items } = dataObj;
    const styles = {
        type: cssStyle?.type ?? defaultStyle.type,
        backColor: cssStyle?.backColor ?? defaultStyle.backColor,
        guideStyle: cssStyle?.guideStyle ?? {},
        titleStyle: cssStyle?.titleStyle ?? {},
        descStyle: cssStyle?.descStyle ?? {},
        config: {
            webpUrl: cssStyle?.webpUrl,
            theme: cssStyle?.config?.theme ?? defaultStyle.config.theme,
            fullScreen: cssStyle?.config?.fullScreen ?? defaultStyle.config.fullScreen,
            fullScreenWidth: cssStyle?.config?.fullScreenWidth ?? defaultStyle.config.fullScreenWidth,
            loop: cssStyle?.config?.loop ?? defaultStyle.config.loop,
            pagination: { ...defaultStyle.config.pagination, ...cssStyle?.config?.pagination },
            icon: { ...defaultStyle.config.icon, ...cssStyle?.config?.icon },
            list: { ...defaultStyle.config.list, ...cssStyle?.config?.list },
            animation: { ...defaultStyle.config.animation, ...cssStyle?.config?.animation },
            textStyle: { ...defaultStyle.config.textStyle, ...cssStyle?.config?.textStyle },
        },
    };
    const { type, backColor, guideStyle, titleStyle, descStyle, config } = styles;
    const types = useContext(swiperTypes);
    type === types.CONTAINER_IMAGE_WITH_TEXT_TOP ||
    type === types.CONTAINER_IMAGE_WITH_TEXT_BOTTOM ||
    type === types.CENTER_IMAGE_WITH_TEXT_TOP ||
    type === types.CENTER_IMAGE_WITH_TEXT_BOTTOM
    ? (config.fullScreen = false)
    : '';
    const isWhiteTheme = backColor === '#fff' || backColor === '#ffffff' || backColor === 'transparent' || backColor === 'white';

    return (
        <div className={`${css.swiperBanner} swiperBanner`} style={{ background: isWhiteTheme ? '#fff' : '#000' }}>
            {type === types.FULL_IMAGE && (
                <CustomerSwiper
                    data={items}
                    cssStyle={{
                        ...config,
                    }}
                />
            )}
            {type === types.FULL_IMAGE_WITH_TEXT_TOP && (
                <div className="textTopWrapper">
                    <div className="container">
                        <TextModule
                            data={guide}
                            cssStyle={{
                                ...{
                                    fontClass: 'font-family-semibold',
                                    fontWeight: 500,
                                    theme: backColor,
                                    fontSize: '32px',
                                    lineHeight: '40px',
                                    margin: '0 0 10px 0',
                                    textAlign: 'center',
                                },
                                ...guideStyle,
                            }}
                        />
                        <TextModule
                            data={title}
                            cssStyle={{
                                ...{
                                    type: 'ls',
                                    margin: '0 0 40px 0',
                                    textAlign: 'center',
                                    theme: backColor,
                                },
                                ...titleStyle,
                            }}
                        />
                        <TextModule
                            cssStyle={{
                                ...{
                                    type: 'sl',
                                    theme: backColor,
                                    fontClass: 'font-family-semibold',
                                    margin: '0 0 90px 0',
                                    textAlign: 'center',
                                },
                                ...descStyle,
                            }}
                            data={desc}
                        />
                    </div>
                    <CustomerSwiper
                        data={items}
                        cssStyle={{
                            ...config,
                        }}
                    />
                </div>
            )}
            {type === types.FULL_IMAGE_WITH_TEXT_BOTTOM && (
                <div className="textBottomWrapper">
                    <CustomerSwiper
                        data={items}
                        cssStyle={{
                            ...config,
                        }}
                    />
                    <div className="container">
                        <TextModule
                            data={guide}
                            cssStyle={{
                                ...{
                                    fontClass: 'font-family-semibold',
                                    fontWeight: 500,
                                    theme: backColor,
                                    fontSize: '32px',
                                    lineHeight: '40px',
                                    margin: '90px 0 10px 0',
                                    textAlign: 'center',
                                },
                                ...guideStyle,
                            }}
                        />
                        <TextModule
                            data={title}
                            cssStyle={{
                                ...{
                                    type: 'ls',
                                    margin: '0 0 40px 0',
                                    textAlign: 'center',
                                    theme: backColor,
                                },
                                ...titleStyle,
                            }}
                        />
                        <TextModule
                            cssStyle={{
                                ...{
                                    type: 'sl',
                                    theme: backColor,
                                    fontClass: 'font-family-semibold',
                                    textAlign: 'center',
                                },
                                ...descStyle,
                            }}
                            data={desc}
                        />
                    </div>
                </div>
            )}
            {type === types.CONTAINER_IMAGE_WITH_TEXT_BOTTOM && (
                <div className="container">
                    <CustomerSwiper
                        data={items}
                        cssStyle={{
                            ...config,
                            ...{ fullScreen: false },
                            ...{ list: { ...{ imgWidth: 1120, imgHeight: 630 }, ...config.list } },
                            ...{
                                icon: {
                                    iconPositionBetween: -73,
                                },
                            },
                        }}
                    />
                    <TextModule
                        data={guide}
                        cssStyle={{
                            ...{
                                fontClass: 'font-family-semibold',
                                fontWeight: 500,
                                theme: backColor,
                                fontSize: '32px',
                                lineHeight: '40px',
                                margin: '90px 0 10px 0',
                                textAlign: 'center',
                            },
                            ...guideStyle,
                        }}
                    />
                    <TextModule
                        data={title}
                        cssStyle={{
                            ...{
                                type: 'ls',
                                margin: '0 0 40px 0',
                                textAlign: 'center',
                                theme: backColor,
                            },
                            ...titleStyle,
                        }}
                    />
                    <TextModule
                        cssStyle={{
                            ...{
                                type: 'sl',
                                theme: backColor,
                                fontClass: 'font-family-semibold',
                                textAlign: 'center',
                            },
                            ...descStyle,
                        }}
                        data={desc}
                    />
                </div>
            )}
            {type === types.CONTAINER_IMAGE_WITH_TEXT_TOP && (
                <div className="container">
                    <TextModule
                        data={guide}
                        cssStyle={{
                            ...{
                                fontClass: 'font-family-semibold',
                                theme: backColor,
                                fontSize: '32px',
                                lineHeight: '40px',
                                textAlign: 'center',
                                margin: '0 0 10px 0',
                                fontWeight: locale === 'cn' ? 400 : 500,
                            },
                            ...guideStyle,
                        }}
                    />
                    <TextModule
                        data={title}
                        cssStyle={{
                            ...{
                                type: 'ls',
                                margin: '0 0 40px 0',
                                textAlign: 'center',
                                theme: backColor,
                                fontWeight: locale === 'cn' ? 600 : 700,
                            },
                            ...titleStyle,
                        }}
                    />
                    <TextModule
                        cssStyle={{
                            ...{
                                type: 'sl',
                                theme: backColor,
                                fontClass: 'font-family-semibold',
                                textAlign: 'center',
                                margin: '0 0 90px 0',
                                fontWeight: locale === 'cn' ? 500 : 600,
                            },
                            ...descStyle,
                        }}
                        data={desc}
                    />
                    <CustomerSwiper
                        data={items}
                        cssStyle={{
                            ...config,
                            ...{ fullScreen: false },
                            ...{ list: { ...{ imgWidth: 1120, imgHeight: 630 }, ...config.list } },
                            ...{
                                icon: {
                                    iconPositionBetween: -73,
                                },
                            },
                        }}
                    />
                </div>
            )}
            {type === types.CENTER_IMAGE_WITH_TEXT_TOP && (
                <div className="centerImageWrapper">
                    <div className="container">
                        <TextModule
                            data={guide}
                            cssStyle={{
                                ...{
                                    fontClass: 'font-family-semibold',
                                    fontWeight: 500,
                                    theme: backColor,
                                    fontSize: '32px',
                                    lineHeight: '40px',
                                    textAlign: 'center',
                                    margin: '0 0 10px 0',
                                },
                                ...guideStyle,
                            }}
                        />
                        <TextModule
                            data={title}
                            cssStyle={{
                                ...{
                                    type: 'ls',
                                    margin: '0 0 40px 0',
                                    textAlign: 'center',
                                    theme: backColor,
                                },
                                ...titleStyle,
                            }}
                        />
                        <TextModule
                            cssStyle={{
                                ...{
                                    type: 'sl',
                                    theme: backColor,
                                    fontClass: 'font-family-semibold',
                                    textAlign: 'center',
                                    margin: '0 0 90px 0',
                                },
                                ...descStyle,
                            }}
                            data={desc}
                        />
                    </div>
                    <CustomerSwiper
                        data={items}
                        cssStyle={{
                            ...config,
                            ...{ fullScreen: false },
                            ...{
                                list: {
                                    ...{ imgWidth: 1120, imgHeight: 630, listGap: 30 },
                                    ...config.list,
                                },
                            },
                            ...{
                                icon: {
                                    insideIcon: true,
                                    iconPositionBetween: 40,
                                },
                            },
                        }}
                    />
                </div>
            )}
            {type === types.CENTER_IMAGE_WITH_TEXT_BOTTOM && (
                <div className="centerImageWrapper">
                    <CustomerSwiper
                        data={items}
                        cssStyle={{
                            ...config,
                            ...{ fullScreen: false },
                            ...{
                                list: {
                                    ...{ imgWidth: 1120, imgHeight: 630, listGap: 30 },
                                    ...config.list,
                                },
                            },
                            ...{
                                icon: {
                                    insideIcon: true,
                                    iconPositionBetween: 40,
                                },
                            },
                        }}
                    />
                    <div className="container">
                        <TextModule
                            data={guide}
                            cssStyle={{
                                ...{
                                    fontClass: 'font-family-semibold',
                                    fontWeight: 500,
                                    theme: backColor,
                                    fontSize: '32px',
                                    lineHeight: '40px',
                                    textAlign: 'center',
                                    margin: '90px 0 10px 0',
                                },
                                ...guideStyle,
                            }}
                        />
                        <TextModule
                            data={title}
                            cssStyle={{
                                ...{
                                    type: 'ls',
                                    margin: '0 0 40px 0',
                                    textAlign: 'center',
                                    theme: backColor,
                                },
                                ...titleStyle,
                            }}
                        />
                        <TextModule
                            cssStyle={{
                                ...{
                                    type: 'sl',
                                    theme: backColor,
                                    fontClass: 'font-family-semibold',
                                    textAlign: 'center',
                                },
                                ...descStyle,
                            }}
                            data={desc}
                        />
                    </div>
                </div>
            )}
        </div>
    );
}
